/**
 * ProductGallery - product media gallery with thumbnail slider and zoom.
 * Custom element: <product-gallery>
 *
 * Attributes (from $info):
 *   listen-to-variant-change  Boolean  false
 *
 * Refs:
 *   [data-ref="slider"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-ThemeCarousel.js";
import "./component-ProductOptionPicker.js";
import { ThemeComponent } from "./theme.js";
import { biggerPicture } from "./vendor.js";
import "./component-ProductButtonOption.js";
import "./component-ProductDropdownOption.js";
import "./component-FakeDropdown.js";
class ProductGallery extends ThemeComponent {
  constructor() {
    super(...arguments), this.swiper = void 0;
  }
  init() {
    if (this.setupLightbox(), this.swiper = this.slider.swiper, this.listenToVariantChange) {
      const optionPickerElement = document.querySelector(".product-option-picker");
      if (optionPickerElement && optionPickerElement.tagName === "PRODUCT-OPTION-PICKER") {
        const optionPicker = optionPickerElement;
        this.$subscribe(optionPicker.onSelectedVariantChange, newVariant => {
          let featuredMediaId = null;
          newVariant != null && newVariant.featured_media && (featuredMediaId = newVariant.featured_media.id), this.handleOnVariantchange(newVariant, featuredMediaId);
        });
      }
    }
  }
  setupLightbox() {
    let lightbox = biggerPicture({
        target: document.body
      }),
      galleryLinks = document.querySelectorAll("#bigger-picture-gallery  a");
    for (let galleryLink of galleryLinks) galleryLink.addEventListener("click", openGallery);
    function openGallery(clickEvent) {
      clickEvent.preventDefault(), lightbox.open({
        items: galleryLinks,
        el: clickEvent.currentTarget,
        intro: "fadeup"
      });
    }
    setFunctionName(openGallery, "openGallery");
  }
  handleOnVariantchange(variant, mediaId) {
    var swiperRef;
    if (this.slider.swiper && variant && mediaId) {
      const slides = [...this.querySelectorAll(".swiper-slide")],
        matchingSlide = slides.find(slide => slide.getAttribute("data-image-id") == String(mediaId));
      if (matchingSlide && matchingSlide.getAttribute("data-image-id")) {
        const slideIndex = slides.indexOf(matchingSlide);
        (swiperRef = this.swiper) == null || swiperRef.slideTo(slideIndex, 300);
      }
    }
  }
}
setFunctionName(ProductGallery, "ProductGallery");
const propertyTypes = {
  Boolean
};
ProductGallery.prototype.$name = "ProductGallery";
ProductGallery.prototype.$info = JSON.parse('{"name":"ProductGallery","meta":{"isLegacy":false,"selector":"product-gallery"},"props":[{"attr":"listen-to-variant-change","default":false,"reflectAttr":false,"propertyKey":"listenToVariantChange","propertyType":"Boolean","propertyTypeName":"Boolean","propertyTsTypeName":"boolean"}],"refs":[{"selector":"[data-ref=\\"slider\\"]","required":true,"propertyKey":"slider","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"Carousel"}]}');
ProductGallery.prototype.$info.component = ProductGallery;
for (const prop of ProductGallery.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductGallery.ts", {
  ProductGallery: ProductGallery
}, void 0);